export default String.raw`
<div class='blog-posts-list-js' style="width: 100%;">
    {% include 'static-elements/blog-container/blog-container.html' -%}
</div>
`